function audioServicePlay(filePath) {
    try {
       console.log('Playing audio: ' + filePath);
       var audio = new Audio(filePath);
       audio.play();

    } catch (e) {
        console.log('Error playing audio: ' + e);
    }
}